import type { HeroSlide, Video } from '@/types/video';

const movieEpisodes = (n: number, base: string): { id: number; title: string; duration: string }[] =>
  Array.from({ length: n }, (_, i) => ({
    id: i + 1,
    title: `${base} 第${i + 1}集`,
    duration: `${40 + (i % 5)}分钟`,
  }));

export const videos: Video[] = [
  {
    id: 'sci-echo',
    title: '星际回响',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20film%20poster%20art%2C%20a%20lone%20astronaut%20before%20a%20colossal%20glowing%20ringed%20planet%2C%20deep%20navy%20and%20amber%20cinematic%20lighting%2C%20atmospheric%20nebula%20dust%2C%20highly%20detailed%20premium%20streaming%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-sci-echo&orientation=portrait',
    tagline: '当信号穿越光年，回响的不只是宇宙',
    description: '一支深空探测队在木星轨道捕获一段来自未来的人类信号，从此踏上追寻真相的旅程。',
    longDescription:
      '《星际回响》讲述深空探测工程师顾言在一次例行监测中，捕获到一段使用人类语言、却标注着未来时间戳的神秘信号。为了验证信号的真伪，他与团队穿越木星轨道，直面未知的宇宙文明。影片以宏大的视觉想象与克制的情感表达，探讨科技、孤独与牺牲的意义。',
    director: '林深',
    actors: ['陆未然', '苏念', '韩之遥'],
    region: '华语',
    year: 2026,
    genres: ['科幻', '冒险'],
    rating: 9.1,
    views: 1284000,
    favorites: 86420,
    updateDate: '2026-10-08',
    episodes: [],
  },
  {
    id: 'long-night',
    title: '长夜将尽',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20suspense%20thriller%20poster%20art%2C%20rainy%20city%20street%20at%20midnight%20with%20a%20single%20glowing%20street%20lamp%2C%20moody%20dark%20teal%20and%20amber%20tones%2C%20mysterious%20atmosphere%2C%20highly%20detailed%20film%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-long-night&orientation=portrait',
    tagline: '每一个谎言，都藏着一个夜晚',
    description: '一桩尘封二十年的旧案，在三名陌生人之间重新浮出水面。',
    longDescription:
      '《长夜将尽》以一场突如其来的暴雨为起点，将三位看似毫无交集的陌生人卷入同一桩悬案。刑警队长沈砚在走访中逐步发现，每个人都在用谎言守护着自己不愿触碰的过去。影片用冷静的镜头语言，把悬念与人性放到同一张牌桌上。',
    director: '陈幕',
    actors: ['周砚', '林清和', '顾南舟'],
    region: '华语',
    year: 2025,
    genres: ['悬疑', '惊悚'],
    rating: 8.6,
    views: 968300,
    favorites: 61250,
    updateDate: '2026-10-05',
    episodes: [],
  },
  {
    id: 'mountain-sea',
    title: '山海故人',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20period%20film%20poster%2C%20mythical%20misty%20mountains%20and%20an%20ancient%20stone%20bridge%2C%20jade%20green%20and%20gold%20tonal%20palette%2C%20epic%20atmospheric%20mood%2C%20highly%20detailed%20oriental%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-mountain-sea&orientation=portrait',
    tagline: '山海有灵，故人重逢',
    description: '上古山海异兽苏醒，一名少年循着祖辈留下的图卷寻访真相。',
    longDescription:
      '《山海故人》取材于东方幻想世界，讲述山野少年白泽为寻找失踪的师父，带着一卷残缺的《山海图》踏入云雾缭绕的古老秘境。在那里，传说中沉睡的异兽与故人一同苏醒。影片以绚丽的东方美学构建出一个既壮阔又温情的奇幻世界。',
    director: '苏慕白',
    actors: ['叶知秋', '温子行', '洛安安'],
    region: '华语',
    year: 2026,
    genres: ['奇幻', '古装'],
    rating: 8.9,
    views: 1120000,
    favorites: 74310,
    updateDate: '2026-10-06',
    episodes: [],
  },
  {
    id: 'ordinary-name',
    title: '平凡之名',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20film%20poster%2C%20warm%20sunlit%20small%20town%20alley%20with%20an%20old%20bicycle%2C%20soft%20amber%20and%20cream%20tones%2C%20tender%20emotional%20mood%2C%20highly%20detailed%20realistic%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-ordinary-name&orientation=portrait',
    tagline: '每一个普通的名字，都值得被认真记住',
    description: '一位退休教师用一本旧名册，串起了小镇几代人的悲欢。',
    longDescription:
      '《平凡之名》讲述了小镇退休教师方守仁，用一本记录了几十年的学生名册，重新走访那些早已散落各地的名字。在一次次重逢与告别的过程中，平凡的人生泛起温暖的光。影片以细腻的笔触描绘普通人的坚韧与善意，被誉为年度最治愈的现实题材作品。',
    director: '何晓川',
    actors: ['谢广和', '安素', '杜小满'],
    region: '华语',
    year: 2025,
    genres: ['剧情', '家庭'],
    rating: 8.4,
    views: 742600,
    favorites: 52880,
    updateDate: '2026-10-02',
    episodes: [],
  },
  {
    id: 'night-runner',
    title: '都市夜行者',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20action%20crime%20poster%2C%20neon%20lit%20city%20rooftop%20at%20night%20with%20a%20running%20silhouette%2C%20deep%20navy%20with%20orange%20neon%20highlights%2C%20tense%20energetic%20mood%2C%20highly%20detailed%20film%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-night-runner&orientation=portrait',
    tagline: '当城市入睡，正义才刚刚醒来',
    description: '一名卧底警探在黑白之间游走，只为揪出幕后黑手。',
    longDescription:
      '《都市夜行者》聚焦城市阴影下的犯罪网络。卧底警探江野潜伏三年，终于接近核心，却发现自己最信任的线人也身兼双重身份。影片以凌厉的动作设计与紧张的节奏，呈现一场关于信念与背叛的较量。',
    director: '梁戈',
    actors: ['秦川', '祝清', '罗一鸣'],
    region: '华语',
    year: 2026,
    genres: ['动作', '犯罪'],
    rating: 8.7,
    views: 1036500,
    favorites: 67420,
    updateDate: '2026-10-07',
    episodes: [],
  },
  {
    id: 'time-mailbox',
    title: '时光信箱',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20romance%20fantasy%20poster%2C%20a%20vintage%20red%20mailbox%20on%20a%20quiet%20snowy%20street%20under%20twilight%2C%20soft%20rose%20and%20mint%20tones%2C%20dreamy%20nostalgic%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-time-mailbox&orientation=portrait',
    tagline: '写下的信，会寄到对的时光',
    description: '一只旧信箱，让相隔十年的两个人开始通信。',
    longDescription:
      '《时光信箱》讲述插画师夏澄在整理外婆旧居时发现一只可以"寄往过去"的信箱。她与十年前的青年摄影师程知远开始通信，两条平行的人生因一封封信逐渐交错。影片以温柔奇幻的设定，讲述关于遗憾、勇气与重逢的故事。',
    director: '许安然',
    actors: ['夏澄', '程知远', '白露'],
    region: '华语',
    year: 2024,
    genres: ['爱情', '奇幻'],
    rating: 8.2,
    views: 658400,
    favorites: 49120,
    updateDate: '2026-09-28',
    episodes: [],
  },
  {
    id: 'desert-journey',
    title: '沙漠孤旅',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20adventure%20drama%20poster%2C%20a%20lone%20wanderer%20crossing%20vast%20golden%20sand%20dunes%20at%20sunset%2C%20warm%20terracotta%20and%20deep%20indigo%20sky%2C%20epic%20lonely%20atmosphere%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-desert-journey&orientation=portrait',
    tagline: '走得越远，越接近自己',
    description: '一位失去记忆的旅人徒步穿越沙漠，只为寻找一张照片的来处。',
    longDescription:
      '《沙漠孤旅》跟随一名身无分文、失去记忆的旅人穿越广袤沙海。他唯一的线索是一张泛黄的照片和一段模糊的旋律。在极端环境与偶遇行者的陪伴中，他逐渐拼凑出属于自己的过去。影片以极简叙事呈现关于自我寻找的深刻命题。',
    director: 'Ethan Cole',
    actors: ['Marcus Reed', 'Elena Vasquez'],
    region: '欧美',
    year: 2025,
    genres: ['冒险', '剧情'],
    rating: 8.5,
    views: 596300,
    favorites: 38710,
    updateDate: '2026-09-30',
    episodes: [],
  },
  {
    id: 'silent-testimony',
    title: '沉默的证词',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20courtroom%20crime%20film%20poster%2C%20empty%20wooden%20courtroom%20with%20a%20single%20spotlight%20on%20the%20witness%20stand%2C%20desaturated%20navy%20and%20cool%20grey%20tones%2C%20tense%20serious%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-silent-testimony&orientation=portrait',
    tagline: '真相从不出声，除非有人替它开口',
    description: '一名年轻的公设辩护人，为一起只有"物证"的案件寻找真相。',
    longDescription:
      '《沉默的证词》讲述公设辩护人柳晴接手一起证据链看似完美的案件。被告始终沉默，唯一的证人早已离世。她不畏压力，从一枚被忽略的指纹开始，层层揭开被掩盖的事实。影片以严谨的推理与冷峻的基调，讨论法律与人性的边界。',
    director: '方格',
    actors: ['柳晴', '沈聿', '程越'],
    region: '华语',
    year: 2026,
    genres: ['悬疑', '犯罪'],
    rating: 8.8,
    views: 872100,
    favorites: 58340,
    updateDate: '2026-10-09',
    episodes: [],
  },
  {
    id: 'jiangshan-moon',
    title: '江山月明',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20historical%20period%20drama%20poster%2C%20ancient%20palace%20under%20a%20full%20moon%20with%20lanterns%20and%20silk%20banners%2C%20rich%20crimson%20gold%20and%20navy%20palette%2C%20grand%20elegant%20mood%2C%20highly%20detailed%20oriental%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-jiangshan-moon&orientation=portrait',
    tagline: '山河为卷，明月作证',
    description: '王朝更迭之际，一位女子以智慧与胆识守护一方山河。',
    longDescription:
      '《江山月明》以架空王朝为背景，讲述长公主萧明昭在乱世中力挽狂澜的传奇。她在权谋与家国之间艰难抉择，以过人的谋略与仁心赢得人心。剧集制作考究，服饰与场景极尽东方气韵，是一部兼具格局与情感的古装大剧。',
    director: '顾长安',
    actors: ['姜晚', '谢景行', '梅映雪'],
    region: '华语',
    year: 2026,
    genres: ['古装', '历史'],
    rating: 9.0,
    views: 2140000,
    favorites: 132600,
    updateDate: '2026-10-10',
    episodes: movieEpisodes(40, '江山月明'),
  },
  {
    id: 'deep-sea',
    title: '深海迷航',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20series%20poster%2C%20a%20deep%20sea%20research%20submarine%20descending%20into%20dark%20bioluminescent%20ocean%20trenches%2C%20deep%20teal%20and%20cyan%20glow%2C%20mysterious%20suspenseful%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-deep-sea&orientation=portrait',
    tagline: '海面之下，藏着另一个世界',
    description: '一支深海科考队在马里亚纳海沟发现无法解释的信号。',
    longDescription:
      '《深海迷航》围绕一支国际深海科考队的极限任务展开。当潜艇下潜至从未到达的深度，科考队捕捉到规律的人造信号，也唤醒了深海中未知的存在。剧集在幽闭的深海空间中营造出层层递进的悬念，探讨人类对未知的敬畏。',
    director: '钱列',
    actors: ['方程', '苏黎', '江屿'],
    region: '华语',
    year: 2025,
    genres: ['科幻', '悬疑'],
    rating: 8.7,
    views: 1560000,
    favorites: 96800,
    updateDate: '2026-10-04',
    episodes: movieEpisodes(24, '深海迷航'),
  },
  {
    id: 'our-ten-years',
    title: '我们的十年',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20urban%20romance%20series%20poster%2C%20two%20young%20people%20on%20a%20city%20bridge%20at%20golden%20hour%2C%20warm%20sunset%20amber%20and%20soft%20mint%20tones%2C%20nostalgic%20tender%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-our-ten-years&orientation=portrait',
    tagline: '兜兜转转，还是你',
    description: '一群大学好友在十年间各自成长，也共同面对生活的起落。',
    longDescription:
      '《我们的十年》以一群大学同窗的十年为尺，丈量青春、友情与爱情的重量。从校园到职场，从相聚到离散，他们在一次次选择中成为更好的自己。剧集以真实细腻的生活流叙事，唤起观众关于成长时代的共同记忆。',
    director: '温静',
    actors: ['许南', '黎晓', '章一诺'],
    region: '华语',
    year: 2024,
    genres: ['都市', '情感'],
    rating: 8.3,
    views: 1180000,
    favorites: 71500,
    updateDate: '2026-09-26',
    episodes: movieEpisodes(36, '我们的十年'),
  },
  {
    id: 'benevolent-heart',
    title: '仁心仁术',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20medical%20drama%20series%20poster%2C%20a%20bright%20modern%20hospital%20corridor%20with%20soft%20morning%20light%2C%20clean%20white%20teal%20and%20navy%20tones%2C%20hopeful%20professional%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-benevolent-heart&orientation=portrait',
    tagline: '每一次抢救，都是与生命的约定',
    description: '急诊科医生们在生死时速中，守护着对职业与人性的信念。',
    longDescription:
      '《仁心仁术》将镜头对准繁忙的急诊科。年轻医生许诺在一次次抢救中领悟医者的责任，也逐渐直面医疗体系与人情冷暖的复杂。剧集以专业而富有温度的方式，呈现医务工作者的日常与坚守。',
    director: '陈启明',
    actors: ['许诺', '高源', '林悦'],
    region: '华语',
    year: 2025,
    genres: ['医疗', '剧情'],
    rating: 8.6,
    views: 1345000,
    favorites: 82600,
    updateDate: '2026-10-01',
    episodes: movieEpisodes(30, '仁心仁术'),
  },
  {
    id: 'foggy-city',
    title: '雾都疑案',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20republic%20era%20mystery%20series%20poster%2C%20foggy%20old%20town%20street%20with%20vintage%20streetlamps%20and%20tram%2C%20sepia%20and%20deep%20teal%20tones%2C%20moody%20period%20suspense%20atmosphere%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-foggy-city&orientation=portrait',
    tagline: '雾散了，真相才会浮现',
    description: '民国探长在一片浓雾笼罩的城中，追查一连串离奇案件。',
    longDescription:
      '《雾都疑案》以民国时期的海港城市为舞台，探长程慕白与女记者沈婉联手侦破一系列看似无关的命案。线索最终指向一桩牵动全城的秘密。剧集以浓郁的年代质感与缜密的推理，重构一段迷雾重重的旧城往事。',
    director: '钟岳',
    actors: ['程慕白', '沈婉', '陆枭'],
    region: '华语',
    year: 2026,
    genres: ['民国', '悬疑'],
    rating: 8.9,
    views: 1420000,
    favorites: 89400,
    updateDate: '2026-10-11',
    episodes: movieEpisodes(28, '雾都疑案'),
  },
  {
    id: 'star-voyage',
    title: '星海征途',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20space%20opera%20series%20poster%2C%20a%20sleek%20starship%20traveling%20past%20a%20giant%20spiral%20galaxy%2C%20deep%20indigo%20with%20electric%20cyan%20and%20gold%20accents%2C%20epic%20awe%20inspiring%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-star-voyage&orientation=portrait',
    tagline: '航向未知，星辰为家',
    description: '一艘星际殖民船踏上数百年航程，船上几代人共同守护同一个目标。',
    longDescription:
      '《星海征途》讲述人类首艘星际殖民船"远航号"飞向新的家园。漫长的航行中，船上世代更替，理想与现实不断碰撞。当船队抵达目的地，等待他们的却是一个颠覆所有预期的答案。剧集以宏大的世界观构建一段关于希望与传承的星际史诗。',
    director: 'Nolan Pierce',
    actors: ['Ava Sterling', 'Noah Grant'],
    region: '欧美',
    year: 2025,
    genres: ['科幻', '冒险'],
    rating: 8.8,
    views: 1680000,
    favorites: 104300,
    updateDate: '2026-10-03',
    episodes: movieEpisodes(20, '星海征途'),
  },
  {
    id: 'white-maze',
    title: '白色迷局',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20korean%20style%20crime%20thriller%20series%20poster%2C%20a%20snow%20covered%20hospital%20building%20at%20blue%20hour%20with%20one%20lit%20window%2C%20cold%20white%20ice%20blue%20and%20slate%20tones%2C%20chilling%20mysterious%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-white-maze&orientation=portrait',
    tagline: '看得见的伤口容易治愈，看不见的呢',
    description: '一所顶级医院内部，隐藏着与几起医疗事故相关的惊人秘密。',
    longDescription:
      '《白色迷局》以一家声名显赫的私立医院为背景，记者尹智浩在调查一起医疗事故时，发现医院光鲜外表下暗藏的利益链条。随着真相逼近，他也被卷入更大的漩涡。剧集节奏紧凑，悬念迭起，探讨正义与良知的代价。',
    director: 'Kim Do-hyun',
    actors: ['Yoon Seo-ah', 'Park Jun-ho'],
    region: '韩剧',
    year: 2026,
    genres: ['悬疑', '犯罪'],
    rating: 8.5,
    views: 1290000,
    favorites: 76400,
    updateDate: '2026-10-09',
    episodes: movieEpisodes(16, '白色迷局'),
  },
  {
    id: 'youth-never-ends',
    title: '青春不散场',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20youth%20campus%20series%20poster%2C%20sunlit%20school%20playground%20with%20a%20running%20track%20and%20green%20trees%2C%20fresh%20mint%20and%20warm%20amber%20tones%2C%20bright%20hopeful%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-youth-never-ends&orientation=portrait',
    tagline: '那年夏天，我们约好不说再见',
    description: '一群高中生在最美好的年纪，一起奔跑、迷惘也被此照亮。',
    longDescription:
      '《青春不散场》记录了一群高二学生在毕业前夕的成长故事。课业压力、朦胧的情愫、与家人的摩擦，都在这段限定时光里被温柔安放。剧集用清新的画面与真挚的情感，还原每个人心中那段闪闪发光的青春。',
    director: '姜沐',
    actors: ['唐可可', '宋一然', '白泽宇'],
    region: '华语',
    year: 2024,
    genres: ['校园', '青春'],
    rating: 8.1,
    views: 966000,
    favorites: 63200,
    updateDate: '2026-09-27',
    episodes: movieEpisodes(32, '青春不散场'),
  },
  {
    id: 'sound-city',
    title: '声动全城',
    type: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20music%20competition%20show%20poster%2C%20a%20glowing%20concert%20stage%20with%20spotlights%20and%20silhouetted%20singer%2C%20vivid%20orange%20and%20deep%20navy%20stage%20lighting%2C%20energetic%20passionate%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-sound-city&orientation=portrait',
    tagline: '用一首歌，点亮一座城',
    description: '来自全国的实力唱将同台竞演，用歌声争夺年度桂冠。',
    longDescription:
      '《声动全城》是一档音乐竞演综艺，汇集不同风格的实力歌手同台比拼。节目以真挚的现场演唱与专业的音乐制作打动观众，每一期都诞生令人难忘的舞台。音乐之外，选手之间的惺惺相惜同样动人。',
    director: '综艺制作组',
    actors: ['主持人 阿黎', '常驻嘉宾 声乐团'],
    region: '华语',
    year: 2026,
    genres: ['音乐', '竞演'],
    rating: 8.7,
    views: 1820000,
    favorites: 98600,
    updateDate: '2026-10-12',
    episodes: movieEpisodes(12, '声动全城'),
  },
  {
    id: 'happy-go',
    title: '快乐出发吧',
    type: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20travel%20reality%20show%20poster%2C%20friends%20laughing%20on%20a%20colorful%20road%20trip%20in%20the%20countryside%2C%20bright%20cheerful%20mint%20orange%20and%20sky%20tones%2C%20fun%20sunny%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-happy-go&orientation=portrait',
    tagline: '收拾行囊，快乐就在路上',
    description: '明星嘉宾组成旅行团，用最放松的方式探索祖国山河。',
    longDescription:
      '《快乐出发吧》让嘉宾卸下光环，以普通旅行者的身份走进各地风景。没有剧本、没有任务，只有一路的欢笑与真实的相处。节目以轻松的节奏，记录旅途中最本真的快乐与温情。',
    director: '综艺制作组',
    actors: ['旅行团长 大宇', '嘉宾团'],
    region: '华语',
    year: 2026,
    genres: ['户外', '真人秀'],
    rating: 8.2,
    views: 1460000,
    favorites: 79300,
    updateDate: '2026-10-11',
    episodes: movieEpisodes(14, '快乐出发吧'),
  },
  {
    id: 'mystery-room',
    title: '谜屋探秘',
    type: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20escape%20room%20reality%20show%20poster%2C%20a%20mysterious%20dim%20room%20with%20glowing%20clues%20and%20vintage%20furniture%2C%20deep%20emerald%20and%20amber%20accents%2C%20curious%20suspenseful%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-mystery-room&orientation=portrait',
    tagline: '每一扇门后，都藏着一个答案',
    description: '六位常驻嘉宾挑战高难度实景推理密室，破解层层谜题。',
    longDescription:
      '《谜屋探秘》是一档沉浸式实景推理综艺。嘉宾被困于精心搭建的故事空间中，需要依靠线索、逻辑与合作逃离密室。节目在紧张的解谜之余，也展现了嘉宾们机智又搞笑的一面。',
    director: '综艺制作组',
    actors: ['常驻嘉宾 六人组'],
    region: '华语',
    year: 2025,
    genres: ['推理', '悬疑'],
    rating: 8.5,
    views: 1370000,
    favorites: 76400,
    updateDate: '2026-10-05',
    episodes: movieEpisodes(12, '谜屋探秘'),
  },
  {
    id: 'food-adventure',
    title: '美食奇遇记',
    type: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20food%20travel%20variety%20show%20poster%2C%20steaming%20local%20street%20food%20market%20at%20dusk%20in%20a%20small%20town%2C%20warm%20amber%20and%20terracotta%20tones%2C%20appetizing%20cozy%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-food-adventure&orientation=portrait',
    tagline: '跟着味道，走进一座城的故事',
    description: '美食家与嘉宾走访各地风味，讲述食物背后的人与情。',
    longDescription:
      '《美食奇遇记》走遍大江南北，寻找藏在街头巷尾的地道风味。每一道菜背后，都有一位坚守多年的手艺人和一段温暖的故事。节目用美食为线索，串联起地方文化与人间烟火。',
    director: '综艺制作组',
    actors: ['美食向导 老墨', '嘉宾团'],
    region: '华语',
    year: 2026,
    genres: ['美食', '旅行'],
    rating: 8.6,
    views: 1190000,
    favorites: 65800,
    updateDate: '2026-10-07',
    episodes: movieEpisodes(10, '美食奇遇记'),
  },
  {
    id: 'hot-band',
    title: '热浪乐队',
    type: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20band%20music%20variety%20show%20poster%2C%20a%20garage%20rehearsal%20room%20with%20electric%20guitars%20and%20warm%20string%20lights%2C%20vivid%20orange%20red%20and%20deep%20navy%20tones%2C%20youthful%20rock%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-hot-band&orientation=portrait',
    tagline: '把青春，唱成最响的那个音',
    description: '素人乐手组队成团，在舞台上用摇滚点燃全场。',
    longDescription:
      '《热浪乐队》汇集来自各行各业的素人乐手，让他们从零组队、排练到登台演出。节目记录他们磨合、争吵与共鸣的全过程，也见证平凡人因音乐而闪闪发光的瞬间。',
    director: '综艺制作组',
    actors: ['音乐导师 老K', '素人乐队'],
    region: '华语',
    year: 2025,
    genres: ['音乐', '乐队'],
    rating: 8.4,
    views: 1030000,
    favorites: 58900,
    updateDate: '2026-10-02',
    episodes: movieEpisodes(12, '热浪乐队'),
  },
  {
    id: 'northbound',
    title: '一路向北',
    type: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20documentary%20travel%20show%20poster%2C%20a%20vast%20snowy%20northern%20landscape%20with%20aurora%20and%20a%20small%20camper%20van%2C%20cool%20ice%20blue%20and%20deep%20teal%20tones%20with%20warm%20light%2C%20serene%20atmospheric%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-northbound&orientation=portrait',
    tagline: '向北，去看更辽阔的风景',
    description: '一档纪实旅行节目，记录从城市到雪原的真实旅程。',
    longDescription:
      '《一路向北》跟随摄制组穿越大半个国家，从繁华城市一路抵达。镜头记录沿途的人、风景与故事，也记录旅途中不期而遇的感动。节目节奏舒缓，画面壮美，是一部适合静下心来看的旅行纪实。',
    director: '综艺制作组',
    actors: ['记录者 阿远'],
    region: '华语',
    year: 2024,
    genres: ['旅行', '纪实'],
    rating: 8.0,
    views: 874000,
    favorites: 49200,
    updateDate: '2026-09-25',
    episodes: movieEpisodes(10, '一路向北'),
  },
  {
    id: 'talk-night',
    title: '脱口秀之夜',
    type: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20stand%20up%20comedy%20show%20poster%2C%20a%20warm%20cabaret%20stage%20with%20a%20microphone%20and%20a%20single%20spotlight%2C%20vivid%20amber%20and%20deep%20navy%20tones%2C%20playful%20upbeat%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-talk-night&orientation=portrait',
    tagline: '生活的苦，笑着讲出来就甜了',
    description: '一群脱口秀演员用幽默解构生活，带来一整晚的笑声。',
    longDescription:
      '《脱口秀之夜》邀请不同风格的脱口秀演员登台，用犀利又温暖的段子讲述普通人的日常。节目在爆笑之外，也藏着对生活的观察与善意，是每周值得期待的快乐时刻。',
    director: '综艺制作组',
    actors: ['主持人 小周', '脱口秀演员'],
    region: '华语',
    year: 2026,
    genres: ['喜剧', '脱口秀'],
    rating: 8.8,
    views: 1610000,
    favorites: 87200,
    updateDate: '2026-10-10',
    episodes: movieEpisodes(16, '脱口秀之夜'),
  },
  {
    id: 'star-sports',
    title: '明星运动汇',
    type: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20sports%20reality%20show%20poster%2C%20athletes%20competing%20on%20a%20bright%20outdoor%20track%20field%2C%20vivid%20orange%20green%20and%20navy%20tones%2C%20dynamic%20energetic%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text&width=480&height=720&seq=cover-star-sports&orientation=portrait',
    tagline: '拼尽全力，就是最好的综艺感',
    description: '明星嘉宾跨界组队，在体育赛场上挥洒汗水与热血。',
    longDescription:
      '《明星运动汇》让艺人走进真实赛场，挑战各类竞技项目。汗水、失误与逆转都毫无保留地呈现，展现竞技体育的紧张与魅力。节目鼓励观众感受运动的快乐与团队精神。',
    director: '综艺制作组',
    actors: ['队长 陈锋', '明星联队'],
    region: '华语',
    year: 2025,
    genres: ['竞技', '真人秀'],
    rating: 8.1,
    views: 1120000,
    favorites: 62400,
    updateDate: '2026-10-06',
    episodes: movieEpisodes(12, '明星运动汇'),
  },
];

export const heroSlides: HeroSlide[] = [
  {
    id: 'sci-echo',
    title: '星际回响',
    typeLabel: '电影 · 科幻',
    category: 'movie',
    tagline: '当信号穿越光年，回响的不只是宇宙',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20film%20key%20art%2C%20a%20lone%20astronaut%20standing%20before%20a%20colossal%20glowing%20ringed%20planet%2C%20deep%20navy%20space%20with%20amber%20rim%20light%2C%20atmospheric%20nebula%20dust%2C%20ultra%20detailed%20epic%20streaming%20backdrop%2C%20no%20text&width=1600&height=900&seq=hero-sci-echo&orientation=landscape',
  },
  {
    id: 'jiangshan-moon',
    title: '江山月明',
    typeLabel: '电视剧 · 古装',
    category: 'tv',
    tagline: '山河为卷，明月作证',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20historical%20drama%20key%20art%2C%20ancient%20oriental%20palace%20under%20a%20huge%20full%20moon%20with%20floating%20lanterns%20and%20silk%20banners%2C%20rich%20crimson%20gold%20and%20navy%20palette%2C%20grand%20elegant%20backdrop%2C%20no%20text&width=1600&height=900&seq=hero-jiangshan-moon&orientation=landscape',
  },
  {
    id: 'deep-sea',
    title: '深海迷航',
    typeLabel: '电视剧 · 科幻',
    category: 'tv',
    tagline: '海面之下，藏着另一个世界',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20key%20art%2C%20a%20research%20submarine%20descending%20into%20a%20dark%20bioluminescent%20deep%20sea%20trench%2C%20deep%20teal%20and%20cyan%20glow%20with%20distant%20light%20rays%2C%20mysterious%20epic%20backdrop%2C%20no%20text&width=1600&height=900&seq=hero-deep-sea&orientation=landscape',
  },
  {
    id: 'mountain-sea',
    title: '山海故人',
    typeLabel: '电影 · 奇幻',
    category: 'movie',
    tagline: '山海有灵，故人重逢',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20oriental%20fantasy%20key%20art%2C%20mythical%20misty%20mountains%20with%20an%20ancient%20stone%20bridge%20and%20glowing%20spirits%2C%20jade%20green%20and%20gold%20tonal%20palette%2C%20epic%20atmospheric%20backdrop%2C%20no%20text&width=1600&height=900&seq=hero-mountain-sea&orientation=landscape',
  },
  {
    id: 'sound-city',
    title: '声动全城',
    typeLabel: '综艺 · 音乐',
    category: 'variety',
    tagline: '用一首歌，点亮一座城',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20music%20stage%20key%20art%2C%20a%20huge%20glowing%20concert%20stage%20with%20spotlights%20and%20a%20silhouetted%20singer%2C%20vivid%20orange%20and%20deep%20navy%20stage%20lighting%2C%20energetic%20epic%20backdrop%2C%20no%20text&width=1600&height=900&seq=hero-sound-city&orientation=landscape',
  },
];